/**
 * Official-style WeChat & Alipay SVG brand icons
 * Usage: <WechatIcon size={24} /> or <AlipayIcon size={24} />
 */

export function WechatIcon({ size = 20, style = {} }) {
  return (
    <svg
      viewBox="0 0 40 40"
      width={size}
      height={size}
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0, ...style }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#07C160" />
      {/*
        WeChat logo: two overlapping speech bubbles
        Large bubble (bottom-left, pointing down-left)
        Small bubble (top-right, pointing up-right)
      */}
      {/* Large white bubble */}
      <path
        d="M8 15.5 C8 11.4 11.8 8 16.5 8 C21.2 8 25 11.4 25 15.5 C25 19.6 21.2 23 16.5 23 C15.6 23 14.7 22.9 13.9 22.6 L10 25 L11.2 21.5 C9.3 20.2 8 18 8 15.5 Z"
        fill="white"
      />
      {/* Large bubble dots */}
      <circle cx="13.5" cy="15.5" r="1.4" fill="#07C160" />
      <circle cx="16.5" cy="15.5" r="1.4" fill="#07C160" />
      <circle cx="19.5" cy="15.5" r="1.4" fill="#07C160" />
      {/* Small bubble (overlapping, offset top-right) */}
      <path
        d="M15 17 C15 14 18.2 11.5 22.2 11.5 C26.2 11.5 29.5 14 29.5 17 C29.5 20 26.2 22.5 22.2 22.5 C21.5 22.5 20.8 22.4 20.1 22.2 L17 24 L18 21.2 C16.2 20.1 15 18.6 15 17 Z"
        fill="white"
        opacity="0.95"
      />
      {/* Small bubble dots */}
      <circle cx="19.8" cy="17" r="1.1" fill="#07C160" />
      <circle cx="22.2" cy="17" r="1.1" fill="#07C160" />
      <circle cx="24.6" cy="17" r="1.1" fill="#07C160" />
    </svg>
  );
}

export function AlipayIcon({ size = 20, style = {} }) {
  return (
    <svg
      viewBox="0 0 40 40"
      width={size}
      height={size}
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0, ...style }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#1677FF" />
      {/*
        Alipay logo: stylised 支 character
        - Top horizontal bar
        - Left diagonal stroke going down-left
        - Right diagonal stroke going down-right
        - Middle horizontal connector
      */}
      {/* Top horizontal */}
      <rect x="11" y="11" width="18" height="2.8" rx="1.4" fill="white" />
      {/* Vertical centre from top bar */}
      <rect x="18.6" y="11" width="2.8" height="5" rx="0" fill="white" />
      {/* Middle horizontal */}
      <rect x="12.5" y="19" width="15" height="2.5" rx="1.25" fill="white" />
      {/* Left diagonal / leg */}
      <path
        d="M14.5 21.5 C13 24.5 12.5 27 14 29 C15 30.5 17 31.5 20 31.5"
        stroke="white" strokeWidth="2.6" fill="none" strokeLinecap="round"
      />
      {/* Right diagonal / leg */}
      <path
        d="M25.5 21.5 C27 24.5 27.5 27 26 29 C25 30.5 23 31.5 20 31.5"
        stroke="white" strokeWidth="2.6" fill="none" strokeLinecap="round"
      />
    </svg>
  );
}

/** Inline tag with icon + label */
export function PaymentMethodBadge({ method, iconSize = 16, fontSize = 12 }) {
  if (method === 'wechat') {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize }}>
        <WechatIcon size={iconSize} />
        微信支付
      </span>
    );
  }
  if (method === 'alipay') {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize }}>
        <AlipayIcon size={iconSize} />
        支付宝
      </span>
    );
  }
  if (method === 'bank_transfer' || method === 'bank') {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize }}>
        🏦 银行转账
      </span>
    );
  }
  return <span style={{ fontSize }}>{method || '—'}</span>;
}
